import { type RefObject, useEffect, useState } from 'react';

/**
 * Checks if the given element is hovered
 * @param ref
 * @returns boolean with the elements hover state
 */
export function useIsHovered(ref: RefObject<HTMLElement>) {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const currentEl = ref.current;

    if (!currentEl) {
      return;
    }

    function mouseEnterHandler() {
      setIsHovered(true);
    }

    function mouseLeaveHandler() {
      setIsHovered(false);
    }

    currentEl.addEventListener('mouseenter', mouseEnterHandler);
    currentEl.addEventListener('mouseleave', mouseLeaveHandler);

    return () => {
      currentEl.removeEventListener('mouseenter', mouseEnterHandler);
      currentEl.removeEventListener('mouseleave', mouseLeaveHandler);
    };
  }, [ref.current]);

  return isHovered;
}
